export default __webpack_public_path__ + "b8587790ee51de507163ac312edd6030.svg";